<template>
  <div class="vx-row">
    <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
      <vx-card title="Add New Master Stock Code">
        <addMasterStockCode></addMasterStockCode>
      </vx-card>
    </div>
    <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
      <vx-card title="Add New Sub Stock Code">
        <addSubStockCode></addSubStockCode>
      </vx-card>
    </div>

  </div>
</template>
<script>
import addMasterStockCode from './addMasterStockCode.vue';
import addSubStockCode from './addSubStockCode.vue';
import axios from '../../axios';
export default {
  components: {
    addMasterStockCode,
    addSubStockCode
  },
  data() {
    return {
    };
  },
  methods: {
  }
}
</script>
